import { supabase } from "@/integrations/supabase/client";

export interface FeatureFlag {
  name: string;
  enabled_for_me: boolean;
}

export async function isReferralSystemEnabled(): Promise<boolean> {
  try {
    const { data, error } = await supabase
      .from("feature_flags_public")
      .select("enabled_for_me")
      .eq("name", "referral_system")
      .maybeSingle();

    if (error) {
      console.error("Error fetching referral system feature flag:", error);
      return false;
    }

    return data?.enabled_for_me ?? false;
  } catch (error) {
    console.error("Error checking referral system feature flag:", error);
    return false;
  }
}

export async function getFeatureFlag(
  flagName: string
): Promise<FeatureFlag | null> {
  try {
    const { data, error } = await supabase
      .from("feature_flags_public")
      .select("name, enabled_for_me")
      .eq("name", flagName)
      .maybeSingle();

    if (error) {
      console.error(`Error fetching feature flag ${flagName}:`, error);
      return null;
    }

    return data;
  } catch (error) {
    console.error(`Error fetching feature flag ${flagName}:`, error);
    return null;
  }
}
